import { render, staticRenderFns } from "./activityWeappAttr.vue?vue&type=template&id=1db03f1a&scoped=true"
import script from "./activityWeappAttr.vue?vue&type=script&lang=js"
export * from "./activityWeappAttr.vue?vue&type=script&lang=js"
import style0 from "./activityWeappAttr.vue?vue&type=style&index=0&id=1db03f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db03f1a",
  null
  
)

component.options.__file = "activityWeappAttr.vue"
export default component.exports